module.exports = __webpack_public_path__ + "media/images/flags-9c74e172.png";